import { useEffect, useState } from 'react'
import NavBar from '../../components/NavBar/NavBar'
import './Home.css'
import { Routes, Route } from 'react-router-dom';
import { getServices } from '../../utilities/api/services';
import SideBar from '../../components/SideBar/SideBar'
import LeadsContent from '../../pageContent/LeadsContent/LeadsContent'
import ClientsContent from '../../pageContent/ClientsContent/ClientsContent'
import ApplicationsContent from '../../pageContent/ApplicationsContent/ApplicationsContent'
import FormsContent from '../../pageContent/FormsContent/FormsContent'
import ProjectsContent from '../../pageContent/ProjectsContent/ProjectsContent'
import UsersContent from '../../pageContent/UsersContent/UsersContent'
import LeadTodosContent from '../../pageContent/LeadTodosContent/LeadTodosContent'
import FormItemContent from '../../pageContent/FormItemContent/FormItemContent'
import ClientItemContent from '../../pageContent/ClientItemContent/ClientItemContent'
import HomeContent from '../../pageContent/HomeContent/HomeContent';
import ApplicationItemContent from '../../pageContent/ApplicationItemContent/ApplicationItemContent';

const defaultDocketPreferences = {
  leadsExclude: [],
  clientsExclude: [],
  formsExclude: [],
  projectsExclude: [],
  patentApplicationsExclude: [],
  trademarkApplicationsExclude: [],
  favoriteClients: [],
}

export default function Home({ user, updateUser, isMobile }) {
  let notificationTimeout
  const [isSideBarExpanded, setIsSideBarExpanded] = useState(true)
  const [services, setServices] = useState([])
  const [docketPreferences, setDocketPreferences] = useState({})


  const updateDocketPreferences = async() => {
      if (user.docketPreferences) {
          const tempDocketPreferences = {}
          Object.keys(user.docketPreferences).forEach((key) => {
              tempDocketPreferences[key] = [...user.docketPreferences[key]]
          })
          Object.keys(defaultDocketPreferences).forEach((key) => {
              if (!tempDocketPreferences[key]) {
                  tempDocketPreferences[key] = []
              }
          })
          setDocketPreferences(tempDocketPreferences)
      } else {
          setDocketPreferences(defaultDocketPreferences)
      }
  }

  const toggleNotifications = (notificationType, text, textcolor) => {
    const mainNotification = document.getElementById('mainNotification')
    mainNotification.innerHTML = text
    mainNotification.classList.add('show')
    mainNotification.classList.add(notificationType)
    mainNotification.style.color = textcolor || '#FFFFFF'
    // Clear the existing timeout if it exists
    if (notificationTimeout) {
      clearTimeout(notificationTimeout);
    }
    notificationTimeout = setTimeout(() => {
      mainNotification.classList.remove('show')
      mainNotification.classList.remove(notificationType)
    }, 5000)
  }

  const getAllServices = async () => {
    try {
      const res = await getServices()
      setServices(res)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    updateDocketPreferences()
    // eslint-disable-next-line
  }, [user])

  useEffect(() => {
    getAllServices()
    // eslint-disable-next-line
  }, [])

  return (
    <div className='Home'>
      <SideBar user={user} updateUser={updateUser} isSideBarExpanded={isSideBarExpanded} setIsSideBarExpanded={setIsSideBarExpanded} isMobile={isMobile}/>
      <div className='mainSection'>
        <NavBar user={user} updateUser={updateUser} updateDocketPreferences={updateDocketPreferences} docketPreferences={docketPreferences} setDocketPreferences={setDocketPreferences} isMobile={isMobile}/>
        <div className='mainContent'>
          <Routes>
          { ['admin', 'manager'].includes(user.userType) &&
          <>
            <Route path='/leads' element={<LeadsContent 
            user={user} 
            isMobile={isMobile} 
            leadsPreferences={docketPreferences.leadsExclude} 
            toggleNotifications={toggleNotifications} />} />

            <Route path='/leads/:leadID' element={<LeadTodosContent 
            user={user} 
            toggleNotifications={toggleNotifications} 
            isMobile={isMobile} />} />

            <Route path='/clients' element={<ClientsContent 
            user={user} 
            updateUser={updateUser}
            isMobile={isMobile}
            clientsPreferences={docketPreferences.clientsExclude}
            setDocketPreferences={setDocketPreferences}
            favoriteClients={docketPreferences.favoriteClients}
            toggleNotifications={toggleNotifications} />} />

            <Route path='/clients/:clientID' element={<ClientItemContent 
            user={user} 
            isMobile={isMobile}
            formsPreferences={docketPreferences.formsExclude}
            projectPreferences={docketPreferences.projectsExclude}
            patentApplicationPreferences={docketPreferences.patentApplicationsExclude}
            trademarkApplicationPreferences={docketPreferences.trademarkApplicationsExclude}
            toggleNotifications={toggleNotifications} />} />

            <Route path='/forms' element={<FormsContent 
            user={user} 
            isMobile={isMobile} 
            formsPreferences={docketPreferences.formsExclude} 
            toggleNotifications={toggleNotifications} />} />

            <Route path='/forms/:formID' element={<FormItemContent 
            user={user} 
            services={services} 
            isMobile={isMobile} 
            toggleNotifications={toggleNotifications} />} />

            <Route path='/applications' element={<ApplicationsContent 
            user={user}
            patentApplicationPreferences={docketPreferences.patentApplicationsExclude}
            trademarkApplicationPreferences={docketPreferences.trademarkApplicationsExclude}
            isMobile={isMobile}
            toggleNotifications={toggleNotifications} />} />

            <Route path='/applications/patent/:applicationID' element={<ApplicationItemContent
            user={user}
            applicationType='patent'
            isMobile={isMobile}
            toggleNotifications={toggleNotifications} />} />

            <Route path='/applications/trademark/:applicationID' element={<ApplicationItemContent
            user={user}
            applicationType='trademark'
            isMobile={isMobile}
            toggleNotifications={toggleNotifications} />} />

            <Route path='/users' element={<UsersContent 
            user={user}
            isMobile={isMobile}
            toggleNotifications={toggleNotifications} />} />
          </>
          }
            <Route path='/summary' element={<HomeContent 
            user={user} />} />
            
            <Route path='/projects' element={<ProjectsContent 
            user={user}
            isMobile={isMobile}
            projectPreferences={docketPreferences.projectsExclude}
            services={services} 
            toggleNotifications={toggleNotifications} />} />
            
            <Route path='/*' element={<HomeContent 
            user={user} />} />
            
          </Routes>
        </div>
        <div id='mainNotification' className='mainNotification'></div>
      </div>
    </div>
  )
}
